export const news = [
  {
    id: "news-1",
    type: "news",
    title: "2026暑期档票房破纪录：科幻与动作类型领跑市场",
    image: "https://readdy.ai/api/search-image?query=busy%20cinema%20lobby%20with%20glowing%20orange%20marquee%20lights%20and%20deep%20blue%20evening%20glass%2C%20modern%20movie%20theatre%20entrance%2C%20cinematic%20warm%20and%20cool%20contrast%2C%20clean%20editorial%20composition%2C%20highly%20detailed%20photography&width=800&height=500&seq=news-01-thumb&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=modern%20cinema%20exterior%20at%20dusk%20with%20bright%20orange%20marquee%20and%20deep%20blue%20sky%2C%20crowd%20of%20moviegoers%2C%20cinematic%20editorial%20color%20grading%2C%20wide%20composition%2C%20highly%20detailed%20photography&width=1600&height=900&seq=news-01-cover&orientation=landscape",
    year: "2026",
    releaseDate: "2026-08-18",
    region: "影视工厂",
    genres: ["行业观察"],
    cast: "影视工厂编辑部",
    director: "—",
    summary: "今年暑期档总票房再创新高，科幻与动作类型成为最大赢家，多部影片口碑票房双丰收。",
    content: [
      "随着暑期档落下帷幕，今年电影市场交出了一份亮眼的成绩单。据统计，档期内总票房较去年同期实现明显增长。",
      "从类型分布来看，科幻与动作题材持续领跑，多部工业化水准较高的作品成为观众热议的焦点。",
      "业内人士分析，观众对高质量视效与扎实故事的需求正在同步提升，内容为王依旧是市场不变的法则。",
    ],
    tags: ["票房", "暑期档", "行业"],
  },
  {
    id: "news-2",
    type: "news",
    title: "年度影视大奖提名公布：多部现实主义题材入围",
    image: "https://readdy.ai/api/search-image?query=elegant%20awards%20ceremony%20stage%20with%20deep%20blue%20backdrop%20and%20warm%20orange%20spotlights%2C%20floating%20golden%20trophies%2C%20cinematic%20editorial%20composition%2C%20highly%20detailed%20event%20photography&width=800&height=500&seq=news-02-thumb&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=grand%20awards%20ceremony%20hall%20with%20deep%20blue%20lighting%20and%20warm%20orange%20stage%20glow%2C%20seated%20audience%20in%20silhouette%2C%20cinematic%20editorial%20color%20grading%2C%20wide%20elegant%20composition%2C%20highly%20detailed%20photography&width=1600&height=900&seq=news-02-cover&orientation=landscape",
    year: "2026",
    releaseDate: "2026-07-22",
    region: "影视工厂",
    genres: ["行业观察"],
    cast: "影视工厂编辑部",
    director: "—",
    summary: "本届大奖提名名单出炉，现实主义题材与女性叙事成为评委关注的重点。",
    content: [
      "年度影视大奖正式公布提名名单，涵盖最佳影片、最佳导演、最佳男女主角等重量级奖项。",
      "从入围作品看，聚焦普通人生活的现实主义题材占据了相当比例，多部口碑之作同时入围。",
      "评委会表示，今年的评选更看重作品的社会价值与人文表达，而非单纯的商业表现。",
    ],
    tags: ["大奖", "提名", "行业"],
  },
  {
    id: "news-3",
    type: "news",
    title: "科幻题材持续升温，国产工业化制作进入新阶段",
    image: "https://readdy.ai/api/search-image?query=behind%20the%20scenes%20film%20studio%20with%20green%20screens%20and%20deep%20blue%20lighting%20plus%20warm%20orange%20set%20lamps%2C%20production%20equipment%2C%20cinematic%20editorial%20composition%2C%20highly%20detailed%20photography&width=800&height=500&seq=news-03-thumb&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=vast%20film%20production%20stage%20with%20giant%20green%20screen%20and%20deep%20blue%20cinematic%20lighting%20with%20warm%20orange%20accents%2C%20camera%20crane%2C%20wide%20industrial%20composition%2C%20highly%20detailed%20photography&width=1600&height=900&seq=news-03-cover&orientation=landscape",
    year: "2026",
    releaseDate: "2026-06-30",
    region: "影视工厂",
    genres: ["技术"],
    cast: "影视工厂编辑部",
    director: "—",
    summary: "从虚拟拍摄到全流程数字化管理，国产科幻电影的制作体系正日益成熟。",
    content: [
      "近年来，越来越多的国产影片开始采用虚拟拍摄、实时渲染等前沿技术，制作效率与视听品质同步提升。",
      "多家影视基地相继建成高科技摄影棚，为科幻、奇幻等重工业题材提供了坚实支撑。",
      "技术是手段，故事才是核心，如何在工业化与创作之间找到平衡，仍是行业持续探索的课题。",
    ],
    tags: ["科幻", "工业化", "技术"],
  },
  {
    id: "news-4",
    type: "news",
    title: "流媒体平台加码原创剧集，内容竞争进入深水区",
    image: "https://readdy.ai/api/search-image?query=cozy%20modern%20living%20room%20with%20a%20big%20screen%20glowing%20warm%20orange%20and%20deep%20blue%2C%20person%20watching%20series%20at%20night%2C%20cinematic%20editorial%20composition%2C%20highly%20detailed%20interior%20photography&width=800&height=500&seq=news-04-thumb&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=multiple%20screens%20and%20devices%20streaming%20shows%20in%20a%20dark%20room%20with%20warm%20orange%20and%20deep%20blue%20glow%2C%20cinematic%20editorial%20color%20grading%2C%20wide%20modern%20composition%2C%20highly%20detailed%20photography&width=1600&height=900&seq=news-04-cover&orientation=landscape",
    year: "2026",
    releaseDate: "2026-06-12",
    region: "影视工厂",
    genres: ["平台"],
    cast: "影视工厂编辑部",
    director: "—",
    summary: "各大流媒体平台纷纷公布片单，原创剧集成为争夺用户注意力的核心战场。",
    content: [
      "随着流媒体用户规模不断扩大，平台之间的内容竞争已从数量转向质量与差异化。",
      "多部高投入原创剧集相继官宣，题材覆盖悬疑、科幻、都市等多元方向。",
      "对观众而言，这无疑意味着更丰富的选择；对创作者而言，则是机遇与挑战并存。",
    ],
    tags: ["流媒体", "原创剧", "平台"],
  },
  {
    id: "news-5",
    type: "news",
    title: "经典IP重启引发热议：情怀与创新如何平衡",
    image: "https://readdy.ai/api/search-image?query=retro%20vintage%20film%20reels%20and%20old%20movie%20posters%20with%20warm%20orange%20lamp%20light%20in%20deep%20blue%20shadows%2C%20nostalgic%20cinematic%20editorial%20composition%2C%20highly%20detailed%20still%20life%20photography&width=800&height=500&seq=news-05-thumb&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=nostalgic%20wall%20of%20classic%20film%20posters%20and%20vintage%20projector%20with%20warm%20orange%20light%20in%20deep%20blue%20room%2C%20cinematic%20editorial%20color%20grading%2C%20wide%20composition%2C%20highly%20detailed%20interior%20photography&width=1600&height=900&seq=news-05-cover&orientation=landscape",
    year: "2026",
    releaseDate: "2026-05-28",
    region: "影视工厂",
    genres: ["评论"],
    cast: "影视工厂编辑部",
    director: "—",
    summary: "一批经典IP宣布重启，观众在期待与担忧之间反复摇摆。",
    content: [
      "多部承载一代人记忆的经典作品先后宣布重启或翻拍，迅速登上热搜。",
      "支持者期待新技术与新视角带来的惊喜，担忧者则害怕情怀被消费、经典被毁。",
      "如何在尊重原作与大胆创新之间取得平衡，成为摆在创作者面前的一道难题。",
    ],
    tags: ["IP", "翻拍", "评论"],
  },
  {
    id: "news-6",
    type: "news",
    title: "青年导演扶持计划启动，为行业注入新鲜血液",
    image: "https://readdy.ai/api/search-image?query=young%20filmmakers%20discussing%20on%20a%20film%20set%20with%20deep%20blue%20evening%20light%20and%20warm%20orange%20set%20lamps%2C%20cameras%20and%20storyboards%2C%20cinematic%20editorial%20composition%2C%20highly%20detailed%20photography&width=800&height=500&seq=news-06-thumb&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=creative%20young%20film%20crew%20collaborating%20on%20set%20with%20deep%20blue%20backlight%20and%20warm%20orange%20lamps%2C%20storyboards%20and%20camera%2C%20wide%20inspiring%20composition%2C%20highly%20detailed%20photography&width=1600&height=900&seq=news-06-cover&orientation=landscape",
    year: "2026",
    releaseDate: "2026-05-10",
    region: "影视工厂",
    genres: ["行业观察"],
    cast: "影视工厂编辑部",
    director: "—",
    summary: "新一季青年导演扶持计划正式启动，将为优质剧本提供资金与资源支持。",
    content: [
      "为推动行业长期健康发展，新一季青年导演扶持计划正式启动，面向全国征集优质剧本。",
      "入选项目将获得资金、制作团队与发行渠道等多维度支持。",
      "主办方表示，希望借此发掘更多有想法、有表达的年轻创作者，为市场带来新鲜视角。",
    ],
    tags: ["青年导演", "扶持", "行业"],
  },
  {
    id: "news-7",
    type: "news",
    title: "暑期观影指南：这些类型片值得走进影院",
    image: "https://readdy.ai/api/search-image?query=colorful%20cinema%20snack%20counter%20with%20popcorn%20and%20tickets%20under%20warm%20orange%20light%2C%20deep%20blue%20background%20with%20neon%20hints%2C%20cinematic%20editorial%20composition%2C%20highly%20detailed%20photography&width=800&height=500&seq=news-07-thumb&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=cinema%20snack%20bar%20with%20popcorn%20tickets%20and%20drinks%20under%20warm%20orange%20lights%20with%20deep%20blue%20neon%20accent%2C%20cinematic%20editorial%20color%20grading%2C%20wide%20inviting%20composition%2C%20highly%20detailed%20photography&width=1600&height=900&seq=news-07-cover&orientation=landscape",
    year: "2026",
    releaseDate: "2026-07-05",
    region: "影视工厂",
    genres: ["推荐"],
    cast: "影视工厂编辑部",
    director: "—",
    summary: "面对密集上映的暑期片单，这份指南帮你快速锁定最值得一看的作品。",
    content: [
      "暑期档向来是兵家必争之地，今年上映影片数量众多，类型也格外丰富。",
      "从视效大片到温情小品，不同口味的观众都能找到心仪之选。",
      "我们结合口碑与票房表现，筛选出几部兼具观赏性与话题度的作品，供你参考。",
    ],
    tags: ["推荐", "观影指南", "暑期档"],
  },
  {
    id: "news-8",
    type: "news",
    title: "幕后揭秘：一部电影的特效是这样诞生的",
    image: "https://readdy.ai/api/search-image?query=vfx%20artist%20workstation%20with%20multiple%20monitors%20showing%203d%20renders%20in%20deep%20blue%20and%20warm%20orange%20glow%20in%20a%20dark%20studio%2C%20cinematic%20editorial%20composition%2C%20highly%20detailed%20photography&width=800&height=500&seq=news-08-thumb&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=vfx%20studio%20with%20rows%20of%20workstations%20showing%20deep%20blue%203d%20renders%20and%20warm%20orange%20highlights%2C%20dark%20high%20tech%20environment%2C%20wide%20cinematic%20composition%2C%20highly%20detailed%20photography&width=1600&height=900&seq=news-08-cover&orientation=landscape",
    year: "2026",
    releaseDate: "2026-04-18",
    region: "影视工厂",
    genres: ["技术"],
    cast: "影视工厂编辑部",
    director: "—",
    summary: "从概念设计到最终合成，带你走进电影特效背后的完整流程。",
    content: [
      "银幕上令人震撼的视觉奇观，背后是数百人团队数月的精密协作。",
      "从概念设计、模型搭建到特效模拟与最终合成，每个环节都容不得半点马虎。",
      "本次我们走访了特效工作室，揭开一部电影特效从无到有的全过程。",
    ],
    tags: ["特效", "幕后", "技术"],
  },
];